import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Status } from '@blade-sxp/tools/interfaces';
let Btn = class Btn extends Vue {
    status;
    Status = Status;
    handleInit() {
        this.$emit('init');
    }
    handleBegin() {
        this.$emit('begin');
    }
};
__decorate([
    Prop(Number)
], Btn.prototype, "status", void 0);
Btn = __decorate([
    Component({
        name: 'btn',
        i18n: {
            messages: {
                en: {
                    reset: 'Reset',
                    reCompare: 'Recompare',
                    compare: 'Start Comparing',
                },
                zh: {
                    reset: '重置',
                    reCompare: '重新比对',
                    compare: '开始比对'
                }
            }
        }
    })
], Btn);
export default Btn;
